const BASE_CONFIG = {
  TRANSLATIONS_HOST: 'https://spa-translations.siteground.com/chat',
  RECAPTCHA_TOKEN: '6LcZEF0sAAAAAAc8vSFdZPsSeMYoTQj5DKKYq1S8',
  RECAPTCHA_TOKEN_2: '6Lde394ZAAAAAPcxktJn7O_aALvfdkZOr-Pf1A-R',
  SALES_CHAT_CONFIGURATION_BY_SITE_ENV: {
    development: {
      IMPULSE_URLS: ['https://local.sgsocket.com:15080', 'https://local.sgsocket.com:16080'],
      // IMPULSE_URLS: ['https://impulse2.sgsocket.com'],
      // IMPULSE_URLS: ['https://192.168.49.2:8080'], // pointing to minikube's cluster loadbalancer
      CHAT_API: 'https://local.chat.siteground.com',
      NEW_CHAT_PROBABILITY_PERCENTAGE: 100
    },
    production: {
      IMPULSE_URLS: ['https://mpulse.sgsocket.com'],
      // IMPULSE_URLS: ['https://impulse2.sgsocket.com'],
      CHAT_API: 'https://megapulse.siteground.com',
      NEW_CHAT_PROBABILITY_PERCENTAGE: 100
    }
  }
};

const DEVELOPMENT_CONFIG = {
  ...BASE_CONFIG,
  RECAPTCHA_TOKEN: '6LeNEV0sAAAAAL5Dp_PyOCuT2j17VOB1HO0X2OF2',
};

const DOCKER_CONFIG = {
  ...BASE_CONFIG,
  RECAPTCHA_TOKEN: '6LeNEV0sAAAAAL5Dp_PyOCuT2j17VOB1HO0X2OF2',
};
const PRODUCTION_CONFIG = {
  ...BASE_CONFIG
};

/**
 * @typedef {Object} SalesChatConfiguration {{
 *   IMPULSE_URLS: string[],
 *   CHAT_API: string,
 *   NEW_CHAT_PROBABILITY_PERCENTAGE: number
 * }}

 */

/**
 * @returns {{
 *   TRANSLATIONS_HOST: string,
 *   RECAPTCHA_TOKEN_2: string,
 *   RECAPTCHA_TOKEN: string,
 *   SALES_CHAT_CONFIGURATION_BY_SITE_ENV: {
 *     production: SalesChatConfiguration,
 *     development: SalesChatConfiguration
 *   }
 * }}
 */
function getConfig() {
  switch (process.env.APP_ENV) {
    case 'docker':
      return DOCKER_CONFIG;
    case 'production':
      return PRODUCTION_CONFIG;
    case 'development':
      return DEVELOPMENT_CONFIG;
    default:
      return BASE_CONFIG;
  }
}

export default getConfig();
